import { Grid, Box } from "@mui/material";
import parse from "html-react-parser";

export default function AllowedDomainss({ orderinstruction }) {
  if (!orderinstruction) return null;

  return (
    <Grid
      container
      spacing={0}
      sx={{
        mt: 2,
        p: { xs: 1.5, sm: 2 },
        border: "1px solid",
        borderColor: "grey.300",
        borderRadius: 2,
        backgroundColor: "grey.50",
      }}
    >
      <Grid item xs={12}>
        <Box
          sx={{
            fontSize: { xs: "12px", sm: "13px", md: "14px" },
            lineHeight: 1.7,
            "& ul": {
              paddingLeft: "20px",
              margin: "8px 0",
            },
            "& li": {
              // marginBottom: "4px",
            },
            "& p": {
              margin: "6px 0",
            },
            "& strong": {
              // fontWeight: 600,
            },
          }}
        >
          {parse(orderinstruction)}
        </Box>
      </Grid>
    </Grid>
  );
}